import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tab from './Tab';

import './Tabs.scss';

/**
 * Generic Tab componene that renders
 * only a single child component based
 * on the active selected tab.
 *
 * @note concept shamefully stolen from
 * @link https://alligator.io/react/tabs-component
 */
class Tabs extends PureComponent {
  static propTypes = {
    /* custom className for all the Tabs item container */
    tabItemsClassname: PropTypes.string,
    /* className for the individual tabs */
    tabClassname: PropTypes.string,
    /* custom className for the active tab */
    activeClassname: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.children[0].props.index,
    };
  }

  /**
   * Show the current tab children when the Tab is clicked
   * @param tabIndex for the active tab
   */
  onClickTab = (tabIndex) => {
    this.setState({ activeTab: tabIndex });
  };

  render() {
    const {
      onClickTab,
      state: { activeTab },
      props: { children, tabItemsClassname, tabClassname, activeClassname },
    } = this;

    const tabsClassname = classNames('Tabs--list', tabItemsClassname);

    return (
      <div className="Tabs" role="tablist">
        <div className={tabsClassname}>
          {children.map((child) => {
            const { label, icon, index, shouldBeHidden } = child.props;

            return (
              !shouldBeHidden && (
                <Tab
                  activeTab={activeTab}
                  key={index}
                  label={label}
                  index={index}
                  onClick={onClickTab}
                  icon={icon}
                  className={tabClassname}
                  activeClassname={activeClassname}
                />
              )
            );
          })}
        </div>

        <div>
          {children.map((child) => {
            const { index, shouldBeHidden } = child.props;
            if (!shouldBeHidden) {
              if (index !== activeTab) return null;
              return child.props.children;
            }
            return null;
          })}
        </div>
      </div>
    );
  }
}

export default Tabs;
